import { Control, Controller, useController, useWatch } from 'react-hook-form';
import ToggleSlider from '../../../../../../common/components/xepp/toggle-slider/ToggleSlider';
import styles from './NotificationForm.module.scss';
import { Input, Select } from '../../../../../customer/components';

const SCREEN_OPTIONS = [
    { label: 'Home', value: '/home_page' },
    { label: 'Buy Electricity', value: '/buy_electricity' },
    { label: 'Energy Management', value: '/energy_management_routing_page' },
    { label: 'Consumption Analytics', value: '/consumption_analytics_page' },
    { label: 'Service Request', value: '/service_request_routing_page' },
    { label: 'Wallet', value: '/wallet_page' },
    { label: 'History', value: '/history_page' },
    { label: 'Family Account Management', value: '/family_account_management' },
    { label: 'Energy Profile', value: '/energy_profile_view_page' },
    { label: 'Change Password', value: '/reset_password_page' },
    { label: 'Change Transaction Pin', value: '/customer_pin_routing_page' },
    { label: 'Change Theme', value: '/appearance_page' },
];

export interface AddButtonFields {
    addButton: boolean;
    linkScreen: string;
    buttonLabel: string;
    buttonUrl: string;
}

export const ADD_BUTTON_DEFAULTS: AddButtonFields = {
    addButton: false,
    linkScreen: '',
    buttonLabel: '',
    buttonUrl: ''
};

export interface AddButtonSectionOption {
    label: string;
    value: string;
}

interface AddButtonSectionProps {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    control: Control<any>;
    label?: string;
    description?: string;
    screenOptions?: AddButtonSectionOption[];
    showButtonLabel?: boolean;
}


const AddButtonSection = ({
    control,
    label = 'Add Button',
    description = 'Add a link or choose a screen to redirect users when they tap the banner.',
    screenOptions = SCREEN_OPTIONS,
    showButtonLabel = true,
}: AddButtonSectionProps) => {
    const addButton = useWatch({ control, name: 'addButton' });
    const { field: screenField, fieldState: screenFieldState } = useController({
        control,
        name: 'linkScreen',
        rules: {
            validate: (value) => {
                if (addButton && !value) {
                    return 'Please select a screen for the button redirect.';
                }
                return true;
            },
        },
    });
    const { field: labelField, fieldState: labelFieldState } = useController({
        control,
        name: 'buttonLabel',
        rules: {
            validate: (value) => {
                if (addButton && showButtonLabel && !value) {
                    return 'Button label is required';
                }
                return true;
            },
        },
    });
    const { field: urlField } = useController({ control, name: 'buttonUrl' });

    const handleScreenChange = (value: string) => {
        screenField.onChange(value);
        urlField.onChange(value ? `${window.location.origin}${value}` : '');
    };


    return (
        <Controller
            name="addButton"
            control={control}
            render={({ field }) => (
                <div className={styles.toggleRow}>
                    <div className={styles.toggleRowMain}>
                        <span className={styles.toggleLabel}>{label}</span>
                        <ToggleSlider isActive={field.value} onChange={field.onChange} />
                    </div>
                    <span className={styles.toggleDescription}>{description}</span>
                    {addButton && (
                        <div className={styles.addButtonExpanded}>
                           
                            <Select
                                placeholder="Select Screen"
                                options={screenOptions}
                                value={screenField.value}
                                onChange={handleScreenChange}
                                variant="light"
                                error={screenFieldState.error?.message}
                            />
                            {showButtonLabel && (
                                <div className={styles.field}>
                                    <label className={styles.label}>Button Label</label>
                                    <Input
                                        variant="light"
                                        value={labelField.value}
                                        onChange={labelField.onChange}
                                        placeholder="Start Now"
                                        error={labelFieldState.error?.message}
                                    />
                                </div>
                            )}
                        </div>
                    )}
                </div>
            )}
        />
    );
};

export default AddButtonSection;
